import { REACT_APP_PERITADOR_API } from '../../config'
import axios from 'axios'

export async function getFiles(verificationId, multimediaType) {
  const response = await axios.get(
    `${REACT_APP_PERITADOR_API}/files?filter[where][verificationsId]=${verificationId}&filter[where][type]=${multimediaType}`
  )
 
  return response.data
}
